import React from "react";

// Uses the provided KHuma logo PNG. `white` renders a monochrome inverted
// (white) version for use on dark backgrounds (footer).
export const KLogo = ({ white = false, className = "" }) => {
  return (
    <img
      src="/logo-khuma.png"
      alt="KHuma Conseil & Stratégie"
      className={`${white ? "brightness-0 invert" : ""} ${className}`}
      draggable={false}
    />
  );
};

export default KLogo;
